import React from "react";
import { Alert, Button } from "react-bootstrap";

/**
 * ExpoNavAlert
 * - pathName (opcional): caminho atual; se não passado usa window.location.pathname
 * - supportedYears: lista de anos que você quer oferecer como opções (ordem preferencial)
 */
const ExpoNavAlert = ({ pathName }) => {
  const supportedYears = [2025, 2024, 2023];

  const path = (pathName || window.location.pathname || "").toLowerCase();
  const match = path.match(/expomacuco\/(anteriores|\d{4})/i);
  const matched = match ? match[1] : null;

  // currentViewed pode ser número (2025...) ou string 'anteriores' ou null
  const currentViewed = matched === "anteriores" ? "anteriores" : (matched ? parseInt(matched, 10) : null);

  // lista de anos a exibir (removendo o ano atual, salvo se estamos em 'anteriores' que mostra todos)
  const yearsToShow = currentViewed === "anteriores"
    ? supportedYears
    : supportedYears.filter(y => y !== currentViewed);

  // label que aparece no texto principal
  const displayLabel = (currentViewed && currentViewed !== "anteriores")
    ? currentViewed
    : "anos anteriores a 2023";

  // base url (se quiser alterar depois)
  const baseUrl = "https://prefeituramacuco.rj.gov.br/transparencia/licitacao/expomacuco";

  return (
    <Alert variant="warning">
      <p>
        Dentro das licitações/dispensas realizadas para Exposição Agropecuária de <strong>{displayLabel}</strong> em Macuco,
        não foi encontrado nenhuma licitação ou dispensa que corresponda a esses filtros.
        Caso queira procurar por licitações ou dispensas não relacionados à Exposição, por favor, clique no link abaixo:
      </p>

      <div className="mb-3">
        <a
          href="https://prefeituramacuco.rj.gov.br/transparencia/licitacao/todas"
          title="Busque por Todas Licitações/Dispensas"
        >
          <Button variant="warning">Todas Licitações/Dispensas</Button>
        </a>
      </div>

      {yearsToShow.map(year => (
        <div className="mb-3" key={year}>
          <p style={{ marginBottom: '0.375rem' }}>
            Caso esteja buscando pelas licitações/dispensas da Exposição de {year}:
          </p>
          <a
            href={`${baseUrl}/${year}`}
            title={`Licitações/Dispensas ${year}`}
          >
            <Button variant="warning">Licitações/Dispensas Expo {year}</Button>
          </a>
        </div>
      ))}

      <div className="mb-2">
        <p style={{ marginBottom: '0.375rem' }}>Caso esteja buscando pelas licitações/dispensas das Exposições de anos anteriores:</p>
        <a
          href={`${baseUrl}/anteriores`}
          title="Licitações/Dispensas anos anteriores"
        >
          <Button variant="warning">Licitações/Dispensas anos anteriores</Button>
        </a>
      </div>
    </Alert>
  );
};

export default ExpoNavAlert;